module.exports = __webpack_public_path__ + "static/media/personalSqr.a85016c2.jpg";